<div *ngIf="errorMsg" class="mb-2">
    <small class="text-danger">{{ errorMsg }}</small>
</div>
